import {
  CurrentLocationDto,
  TrailerGpsLocationDto,
  VehicleIgnitionStatus,
} from "../../common/data/service-proxies";

export type ControlPosition =
  | "TOP_CENTER"
  | "TOP_LEFT"
  | "TOP_RIGHT"
  | "LEFT_TOP"
  | "RIGHT_TOP"
  | "LEFT_CENTER"
  | "RIGHT_CENTER"
  | "LEFT_BOTTOM"
  | "RIGHT_BOTTOM"
  | "BOTTOM_CENTER"
  | "BOTTOM_LEFT"
  | "BOTTOM_RIGHT";

export interface LiveTrackEvent {
  lat?: number | null;
  lng?: number | null;
  bearing?: number | null;
  speed?: number | null;
  driverName?: string | null;
  trailers?: string | null;
  geolocation?: string | null;
  deviceHasPermissions?: boolean | null;
  timestamp?: string;
}

export interface MapImperativeControls {
  resetView: () => void;
  panToCoordinates: (
    coordinates: Array<{ lat?: number; lng?: number }>
  ) => void;
  setCenter: (coordinates: { lat: number; lng: number }) => void;
  setZoom: (zoom: number) => void;
}

export interface MapMarkerImperativeControls {
  setPopupShown: (shown: boolean) => void;
}

interface MapBoundsChangedEventArgs {
  southWest?: google.maps.LatLng;
  zoom?: number;
  projection?: google.maps.Projection;
}

export type MapBoundsChangedListener = (
  payload: MapBoundsChangedEventArgs
) => void;

export type InfoPopupArrowPosition = "bottom" | "top";

export interface IMarkerBase {
  id: number | string;
  lat: number;
  lng: number;
  iconPath?: string;
  title?: string;
  markerColor?: string;
  bearing: number;
  isPluggedUpdateTime?: string | null;
  ignitionStatusUpdateTime?: string | null;
  fuelLevelUpdateTime?: string | null;
  fuelLevel?: string | null;
  infoWindowContent?: React.ReactElement<
    TrailerGpsLocationDto | CurrentLocationDto
  >;
  type: LocationsFetchType;
  ignitionStatus?: VehicleIgnitionStatus | null;
  dutyStatus: string;
  eldConnected?: boolean | null;
  isPlugged?: boolean | null;
  onClick: () => void;
}

export interface GoogleMapControls extends MapImperativeControls {
  initMarkers: (markers: Array<IMarkerBase>) => void;
  hideMarkers: (selector: (marker: IMarkerBase) => boolean) => void;
  updateMarker: (
    id: string | number,
    func: (inputMarker: IMarkerBase) => IMarkerBase
  ) => void;
  clearMarkers: () => void;
  setCenter: (coordinates: { lat: number; lng: number }) => void;
  setZoom: (zoom: number) => void;
  moveCamera: (camera: google.maps.CameraOptions) => void;
  resetView: () => void;
  disableClustering: () => void;
  enableClustering: () => void;
}

export enum LocationsFetchType {
  Trucks = 1 << 0,
  Trailers = 1 << 1,
  All = ~(~0 << 2),
}
